import React from "react";

export default function TestingZone() {
  return (
    <div>
      <h5>Welcome to the testing zone!</h5>
    </div>
  );
}
